import React from "react";
import { CustomTableRow, CustomTableCell } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "../phase-row/PhaseRow.module.css";

const HeaderPhaseRow = ({ isEditable, order, orderBy, onSort, isArchivedTab = false }) => (
	<CustomTableRow>
		<CustomTableCell
			active={orderBy === "position"}
			className={styles.orderNameCell}
			direction={order}
			sortKey="position"
			onSort={() => onSort("position")}
		>
			{" "}
			<div style={{ display: "flex", gap: "8px" }}>
				<div>{translate("project-phases.header.phaseNumber")}</div>
				<div>{translate("project-phases.header.name")}</div>
			</div>
		</CustomTableCell>
		<CustomTableCell
			active={orderBy === "description"}
			className={styles.descriptionCell}
			direction={order}
			sortKey="description"
			onSort={() => onSort("description")}
		>
			{translate("project-phases.header.description")}
		</CustomTableCell>
		{isArchivedTab ? (
			<CustomTableCell
				active={orderBy === "archiveDate"}
				className={styles.dateCell}
				direction={order}
				sortKey="archiveDate"
				onSort={() => onSort("archive_date")}
			>
				{translate("project-phases.header.archiveDate")}
			</CustomTableCell>
		) : (
			<>
				<CustomTableCell
					active={orderBy === "startDate"}
					className={styles.dateCell}
					direction={order}
					sortKey="startDate"
					onSort={() => onSort("start_date")}
				>
					{translate("project-phases.header.startDate")}
				</CustomTableCell>
				<CustomTableCell
					active={orderBy === "endDate"}
					className={styles.dateCell}
					direction={order}
					sortKey="endDate"
					onSort={() => onSort("end_date")}
				>
					{translate("project-phases.header.endDate")}
				</CustomTableCell>
			</>
		)}
		<CustomTableCell
			active={orderBy === "deliverables"}
			className={styles.deliverablesCell}
			direction={order}
			sortKey="deliverables"
			style={{ whiteSpace: "nowrap" }}
			onSort={() => onSort("deliverables_count")}
		>
			{translate("project-phases.header.deliverables")}
		</CustomTableCell>
		{isEditable && <CustomTableCell className={styles.actionsCell} />}
	</CustomTableRow>
);

export default HeaderPhaseRow;
